import { createRootRouteWithContext } from "@tanstack/react-router";
import Root from "../Root";
import { TAuth } from "@Reducers/Authentication.reducer";
import { QueryClient } from "@tanstack/react-query";
import { UseTranslationResponse } from "react-i18next";

export interface RouterContext {
  authentication: TAuth | undefined;
  queryClient: QueryClient | undefined;
  translation: UseTranslationResponse<"tr", undefined> | undefined;
}

export const RootRoute = createRootRouteWithContext<RouterContext>()({
  component: Root,
});
